import { t } from 'ttag';

import { Modal } from '@ui/Modal';
import { Title } from '@ui/Title';
import { Button } from '@ui/Button';
import { Image } from '@ui/Image';

import s from './CharacteristicOverviewModal.sss';

interface Option {
  title: string,
  id: number,
  description?: string | null,
  icon?: string | null,
}

interface Props {
  isOpen: boolean,
  title: string,
  options: Option[],
  onClose: () => void,
}

export const CharacteristicOverviewModal: React.FC<Props> = ({
  isOpen,
  title,
  options,
  onClose,
}) => (
  <Modal
    className={s.modal}
    isOpen={isOpen}
    withClose={false}
  >
    <Title
      className={s.title}
      type="h3"
      bold={false}
    >
      {title}
    </Title>

    <ul className={s.list}>
      {options.map((option) => (
        <li
          key={option.id}
          className={s.item}
        >
          {!!option.icon && (
            <Image
              className={s.icon}
              src={option.icon}
              width="24"
              height="24"
            />
          )}

          <div>
            <p className={s.label}>
              {option.title}
            </p>
            <p className={s.description}>
              {option.description}
            </p>
          </div>
        </li>
      ))}
    </ul>

    <Button
      className={s.button}
      theme="primary"
      onClick={onClose}
    >
      {t`Добре`}
    </Button>
  </Modal>
);
